/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React, { useEffect, useRef, useState } from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { DialpadSquare01Icon } from '@hugeicons-pro/core-solid-rounded';
import { useSelector } from 'react-redux';
import type { RootState } from '../store/store';
import type { appConfigs } from './types/types';
import axios from 'axios';

interface UserProduct {
  productId: number;
  productName: string;
  feUrl: string;
  beUrl: string;
  userRoleId: number;
  userId: number;
  isDefaultProduct: boolean;
  imageURL?: string | null;
}

function ProductIcon({ imageURL, name }: { imageURL?: string; name: string }): React.JSX.Element {
  const [imgError, setImgError] = useState(false);
  if (imageURL === undefined || imageURL === '' || imgError) {
    return <span className="text-base font-semibold leading-none">{name.charAt(0).toUpperCase()}</span>;
  }
  return (
    <img src={imageURL} alt={name} className="h-6 w-6 object-contain" onError={() => setImgError(true)} />
  );
}

async function fetchUserProducts(userId: number, engageBaseUrl: string): Promise<UserProduct[]> {
  const token = sessionStorage.getItem('engagetoken');
  console.log(token);
  const base = engageBaseUrl.replace(/\/$/, '');
  const response = await axios.get<{ success: boolean; data: UserProduct[] }>(
    `${base}/api/product/getuserproducts/${userId}`,
    { headers: token !== null ? { Authorization: `Bearer ${token}` } : {} }
  );
  return response.data.success ? response.data.data : [];
}

function AppLauncher(): JSX.Element {
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState<UserProduct[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const hasFetched = useRef(false);

  const user = useSelector((state: RootState) => state.auth.user);
  const appConfigs = useSelector((state: RootState) => state.auth.appConfigs) as unknown as appConfigs[] | null;

  const engageFeUrl = appConfigs?.find(
    (c) => c.configType === 'EngageApp' && c.configName === 'BaseURLFE'
  )?.configValue ?? '';

  const engageBeUrl = appConfigs?.find(
    (c) => c.configType === 'EngageApp' && c.configName === 'BaseURLBE'
  )?.configValue ?? '';

const engageImgUrl = appConfigs?.find(
    (c) => c.configType === 'EngageApp' && c.configName === 'ImageUrl'
  )?.configValue ?? '';
  const engageProduct: UserProduct = {
    productId: 0,
    productName: 'Engage',
    feUrl: engageFeUrl,
    beUrl: engageBeUrl,
    imageURL:engageImgUrl,
    userRoleId: 0,
    userId: user?.id ?? 0,
    isDefaultProduct: false,
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = (): void => {
    const next = !open;
    setOpen(next);

    if (next && !hasFetched.current && user !== null && user !== undefined) {
      setLoading(true);
      setError(null);
      fetchUserProducts(user.id, engageBeUrl)
        .then((data) => {
          setProducts([engageProduct, ...data]);
          hasFetched.current = true;
        })
        .catch(() => {
          setError('Failed to load applications.');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const isCurrentApp = (feUrl: string): boolean => {
    try {
      return new URL(feUrl).origin === window.location.origin;
    } catch {
      return false;
    }
  };

  const handleSelect = (product: UserProduct): void => {
    if (isCurrentApp(product.feUrl)) return;
    setOpen(false);
    window.location.assign(product.feUrl);
  };

  return (
    <div ref={containerRef} className="relative ml-4">
      <button
        type="button"
        onClick={handleToggle}
        className="app-launcher-trigger"
        title="Applications"
      >
        <HugeiconsIcon
          icon={DialpadSquare01Icon}
          size={20}
          color="#4D5E71"
        />
      </button>

      {open && (
        <div className="app-launcher-panel">
          <div className="app-launcher-arrow" />
          <div className="app-launcher-panel-title">Applications</div>

          {loading && (
            <div className="flex items-center justify-center py-6">
              <div className="app-launcher-spinner" />
            </div>
          )}

          {!loading && error !== null && (
            <p className="app-launcher-error">{error}</p>
          )}

          {!loading && error === null && (
            <ul className="app-launcher-list">
              {products.map((product) => {
                const current = isCurrentApp(product.feUrl);
                return (
                  <li key={product.productId}>
                    <button
                      type="button"
                      onClick={() => handleSelect(product)}
                      disabled={current}
                      className={`app-launcher-item${current ? ' app-launcher-item--current' : ''}`}
                    >
                      <span className="app-launcher-icon">
                        <ProductIcon imageURL={product.imageURL ?? undefined} name={product.productName} />
                      </span>
                      <span className="app-launcher-name">{product.productName}</span>
                      {current && (
                        <span className="app-launcher-badge">Current</span>
                      )}
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}

export default AppLauncher;
